/**
 * Icône Lucide du système (design system, Icone) : 16 px, trait de 1,5 px, couleur du texte.
 * Seules les icônes du groupe design-system/assets/Icons existent ; leur dessin est repris
 * tel quel des fichiers SVG.
 */
const fichiers = import.meta.glob<string>('../../../design-system/assets/Icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
});

export const NOMS_ICONES = [
  'arrow-big-up',
  'arrow-left',
  'arrow-up-down',
  'bold',
  'braces',
  'calendar',
  'chart-column',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle-alert',
  'circle-check',
  'circle-pause',
  'circle-x',
  'clock',
  'cloud-off',
  'code',
  'command',
  'copy',
  'corner-down-left',
  'ellipsis',
  'eraser',
  'external-link',
  'eye',
  'eye-off',
  'folder',
  'folder-open',
  'folder-plus',
  'grip-vertical',
  'heading-1',
  'heading-2',
  'heading-3',
  'highlighter',
  'hourglass',
  'image',
  'info',
  'italic',
  'keyboard',
  'layers',
  'link',
  'list',
  'list-filter',
  'list-ordered',
  'lock',
  'log-out',
  'mail',
  'minus',
  'monitor',
  'moon',
  'palette',
  'pencil',
  'pipette',
  'play',
  'plus',
  'rectangle-horizontal',
  'refresh-cw',
  'rotate-ccw',
  'search',
  'settings',
  'sigma',
  'square-dashed',
  'square-dashed-mouse-pointer',
  'strikethrough',
  'sun',
  'table',
  'target',
  'text-quote',
  'timer',
  'trash-2',
  'triangle-alert',
  'undo-2',
  'user',
  'x',
] as const;

export type NomIcone = (typeof NOMS_ICONES)[number];

/** Contenu de chaque SVG (formes seules, sans la balise `svg`). */
const dessins = new Map<string, string>(
  Object.entries(fichiers).map(([chemin, svg]) => [
    chemin.replace(/^.*\/(.+)\.svg$/, '$1'),
    svg
      .replace(/^[\s\S]*?<svg[^>]*>/, '')
      .replace(/<\/svg>[\s\S]*$/, '')
      .trim(),
  ]),
);

export interface IconeProps {
  nom: NomIcone;
  /** 16 px (icone) ou 14 px (icone-petite). Défaut : normale. */
  taille?: 'normale' | 'petite';
  /** Nom accessible quand l'icône porte seule un sens ; sinon elle est décorative. */
  etiquette?: string;
  className?: string;
}

export function Icone({ nom, taille = 'normale', etiquette, className }: IconeProps) {
  const classes = ['fc-icone', taille === 'petite' ? 'fc-icone--petite' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <svg
      className={classes}
      viewBox="0 0 24 24"
      {...(etiquette === undefined
        ? { 'aria-hidden': true }
        : { role: 'img', 'aria-label': etiquette })}
      dangerouslySetInnerHTML={{ __html: dessins.get(nom) ?? '' }}
    />
  );
}
